import { useSelector } from 'react-redux';

import { getGlobalIsSingleFileModeEnabled } from 'src/redux/diff-settings';
import { getIsSingleFileModeActive } from 'src/redux/pull-request/selectors';

export const useIsSingleFileModeActive = () => {
  const isGlobalSingleFileModeEnabled = useSelector(
    getGlobalIsSingleFileModeEnabled
  );

  const isSingleFileModeActive = useSelector(getIsSingleFileModeActive);

  return { isGlobalSingleFileModeEnabled, isSingleFileModeActive };
};
